var React = require('react');

function DesignTokensIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_901_10929)","key":0},[React.createElement("rect",{"width":"75","height":"75","rx":"5","fill":"#EAF1FA","key":0}),React.createElement("circle",{"cx":"38","cy":"21","r":"11","fill":"#3874CB","key":1}),React.createElement("rect",{"x":"10","y":"39","width":"22","height":"22","fill":"#3267B4","key":2}),React.createElement("path",{"d":"M54.5 39L67.0574 60.75H41.9426L54.5 39Z","fill":"#83B7F0","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_901_10929"},React.createElement("rect",{"width":"75","height":"75","fill":"white"})))]);
}

DesignTokensIcon.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = DesignTokensIcon;

DesignTokensIcon.default = DesignTokensIcon;
